import Banner from '@/components/Banner2';
import Title from '@/components/Title/index.vue';
import Cases from '@/components/Cases/index.vue';
import ProgramComposition from './components/ProgramComposition.vue';
import Appointment2 from '@/components/Appointment2/index.vue';
export default {
  components: {
    Banner,
    Title,
    Cases,
    ProgramComposition,
    Appointment2
  },
  data() {
    return {
      healthImgUrl: require('@/assets/images/solution/health-care/HealthcareSolutions-xiaohua.png'),
      imageUrl: require('@/assets/images/solution/health-care/HealthcareSolutions-banner.png'),
      scenariosImgUrl: require('@/assets/images/solution/health-care/healthcareSolutions-scenarios1.png'),
      bannerTitle: '医疗解决方案',
      bannerText: '同花顺医疗解决方案聚焦图像处理、自然语言处理等人工智能技术在医疗健康领域的研发应用，现有人工智能影像辅助诊断、人工智能语音辅医、人工智能科研三大产品体系，核心产品包括消化内镜、放射影像、病理辅助诊断系统，大数据科研系统以及智能语音转写、语音随访系统等。',
      coreFunctionList: [[{
        img: require('@/assets/images/solution/health-care/healthcareSolutions-core1.png'),
        desc: '遗漏部位展示'
      }, {
        img: require('@/assets/images/solution/health-care/healthcareSolutions-core2.png'),
        desc: '手术操作导航'
      }, {
        img: require('@/assets/images/solution/health-care/healthcareSolutions-core3.png'),
        desc: '自动保存截图'
      }, {
        img: require('@/assets/images/solution/health-care/healthcareSolutions-core4.png'),
        desc: '多维质控评分 '
      }], [{
        img: require('@/assets/images/solution/health-care/healthcareSolutions-core5.png'),
        title: '智能骨折检测',
        desc1: '·秒级骨折分析',
        desc2: '·精准骨折定位',
        desc3: '·效率提升8倍'
      }, {
        img: require('@/assets/images/solution/health-care/healthcareSolutions-core6.png'),
        title: '肋骨智能曲面重建',
        desc1: '·排除干扰因素',
        desc2: '·肋骨序列编号',
        desc3: '·保留原始细节'
      }, {
        img: require('@/assets/images/solution/health-care/healthcareSolutions-core7.png'),
        title: '重建图与CT三断面交互',
        desc1: '·四视图同步交互',
        desc2: '·辅助精准判断辅助精准判断'
      }], [{
        img: require('@/assets/images/solution/health-care/healthcareSolutions-core8.png'),
        title: '诊前提醒',
        desc1: '智能预约',
        desc2: '就诊提醒',
        desc3: '体征收集',
        desc4: '术前宣教'
      }, {
        img: require('@/assets/images/solution/health-care/healthcareSolutions-core9.png'),
        title: '院后随访',
        desc1: '术后随访',
        desc2: '慢病随访',
        desc3: '健康指导',
        desc4: '复诊提醒'
      }, {
        img: require('@/assets/images/solution/health-care/healthcareSolutions-core10.png'),
        title: '智能客服',
        desc1: '全天候服务',
        desc2: '智能问答',
        desc3: '分诊导诊',
        desc4: '渠道引流'
      }], [{
        img: require('@/assets/images/solution/health-care/healthcareSolutions-core11.png'),
        title: '疾控管理',
        desc1: '海量外呼',
        desc2: '快速通知',
        desc3: '疫苗提醒',
        desc4: '人员流调和报表反馈'
      }]],
      leftItems: [{
        img: require('@/assets/images/solution/health-care/HealthcareSolutions-QC.png'),
        activeImg: require('@/assets/images/solution/health-care/HealthcareSolutions-QC-active.png'),
        bgImg: require('@/assets/images/solution/health-care/healthcareSolutions-high.png'),
        title: '小花探影®消化内镜辅助质量控制系统'
      }, {
        img: require('@/assets/images/solution/health-care/HealthcareSolutions-aided.png'),
        activeImg: require('@/assets/images/solution/health-care/HealthcareSolutions-aided-active.png'),
        bgImg: require('@/assets/images/solution/health-care/healthcareSolutions-high.png'),
        title: '智能骨折辅助分析系统'
      }, {
        img: require('@/assets/images/solution/health-care/HealthcareSolutions-aiassistant.png'),
        activeImg: require('@/assets/images/solution/health-care/HealthcareSolutions-aiassistant-active.png'),
        bgImg: require('@/assets/images/solution/health-care/healthcareSolutions-high.png'),
        title: '智能医疗语音助手'
      }],
      activeIndex: 0
    };
  },
  methods: {
    changeActive(e, index) {
      if (this.activeIndex === index) {
        return;
      }
      this.activeIndex = index;
    }
  }
};